<!--
  ~ Copyright (c) 2022 Certusoft, Inc. All Rights Reserved.
  ~
  ~ This SOURCE CODE FILE, which has been provided by Certusoft as part
  ~ of a Certusoft product for use ONLY by licensed users of the product,
  ~ includes CONFIDENTIAL and PROPRIETARY information of Certusoft.
  ~
  ~ USE OF THIS SOFTWARE IS GOVERNED BY THE TERMS AND CONDITIONS
  ~ OF THE LICENSE STATEMENT AND LIMITED WARRANTY FURNISHED WITH
  ~ THE PRODUCT.
  -->

<div class="login-bg">
    <!--  <div class="navbar navbar-default navbar-static-top">-->
    <!--    <div class="container-fluid">-->
    <!--      &lt;!&ndash; Brand and toggle get grouped for better mobile display &ndash;&gt;-->
    <!--      <div class="navbar-header">-->
    <!--        <a class="navbar-brand logo" data-ui-sref="home"></a>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  </div>-->

    <div class="login-wrapper">
        <div class="alert alert-danger" [hidden]="!error && !customError">
            {{ customError }}
            <span ng-if="error">
                <span translate="LOGIN.ERROR">Error: </span> <span>{{ message }}.</span>
            </span>
        </div>
        <div class="form-login">
            <form [formGroup]="form" (ngSubmit)="login()">
                <formly-form [model]="credentials" [fields]="credentialFields" [form]="form">
                    <button
                        type="submit"
                        class="btn btn-primary submit-button"
                        ng-disabled="credentialForm.$invalid"
                        translate="LOGIN.SUBMIT"
                    >
                        Submit
                    </button>
                </formly-form>
            </form>
        </div>
    </div>

    <footer>
        <div class="container text-center">
            <span class="copyright" translate="LOGIN.COPYRIGHT">
                Copyright &copy; 2022 <a href="http://certusoft.com/" title="Certusoft.com">Certusoft, Inc.</a>
            </span>
        </div>
    </footer>
</div>
